<template>
    <table class="flex-fill table table-head-fixed table-hover text-nowrap">
        <thead style="font-size: 0.85rem">
            <tr style="color: #1976d2; font-weight: 500">
                <th class="text-center text-nowrap" style="width: 12.5rem">
                    <button>
                        <span>Invoice ID</span>
                    </button>
                </th>
                <th class="text-right text-nowrap" style="width: 10rem">
                    <button>
                        <span>Status</span>
                    </button>
                </th>
                <th class="text-left text-nowrap">
                    <button>
                        <span>Payment method</span>
                    </button>
                </th>
                <th class="text-right text-nowrap" style="width: 10rem">
                    <button>
                        <span>Amount</span>
                    </button>
                </th>
                <th class="text-right text-nowrap" style="width: 10rem">
                    <button>
                        <span>iRender point</span>
                    </button>
                </th>
                <th style="width: 1%"></th>
                <th style="width: 1%"></th>
            </tr>
        </thead>
        <tbody style="color: #616161; font-size: 0.85rem">
            <tr :key="element.id" v-for="element in listData" 
                :style="`${element.type === dict.transactionType.PROCESSING ? '#616161' : 'background-color: #F4FAF4' }`">
                <td class="v-center text-nowrap text-center pt-2 pb-2">
                    <div v-if="element.transactionId" style="text-shadow: 2px 2px #ffffff">
                        {{ element.transactionId }}
                    </div>
                    <div v-else style="color: #bdbdbd">-- -- -- -- -- -- --</div>
                </td>
                <td class="v-center text-nowrap text-right">
                    <span :class="`${dict.paymentStyleStatusText[element.status]}`"
                        style="padding: 0.25rem 0.75rem; border-radius: 1rem">
                        <i :class="`${dict.paymentStatusIcon[element.status]}`" style="font-size: 0.8rem"></i>
                        <span class="ml-2">{{
                            $t(dict.paymentStatusText[element.status])
                        }}</span>
                    </span>
                </td>
                <td class="v-center text-nowrap text-left pt-2 pb-2">
                    <div class="d-flex flex-row align-items-center">
                        <div class=" d-flex flex-row align-items-center justify-content-center mr-2 ">
                            <img style="width: 2rem"
                                :src="`/providerTransaction/${element.paymentMethodId}.svg`" />
                        </div>
                        <div class="ml-3">
                            <div style="font-weight: 500" :style="`${element.type === dict.transactionType.PROCESSING
                                    ? 'color: #757575;'
                                    : 'color: forestgreen; text-shadow: 2px 2px #ffffff;'
                                }`">
                                {{ element.paymentMethodDescription }}
                            </div>
                            <div class="mt-1" style="font-size: 0.75rem; color: #9e9e9e">
                                {{ element.lastModifiedAt | pretyDateUtcToLocal }}
                            </div>
                        </div>
                    </div>
                </td>
                <td class="v-center text-nowrap text-right pt-2 pb-2">
                    <div style="font-weight: 500" 
                        :style="`color: ${element.type === dict.transactionType.PROCESSING ? '#616161' : 'forestgreen' }`">
                        <span style="font-weight: 500">$</span>
                        <span class="ml-1">{{ element.amount }}</span>
                    </div>
                </td>
                <td class="v-center text-nowrap text-right pt-2 pb-2">
                    <div>
                        <div title="iRender point" 
                            class=" d-flex justify-content-end align-items-center flex-row " 
                            :style="`${element.irenderPoint === 0 ? 'opacity: 0.25' : '' }`">
                            <div style="color: #42a5f5">
                                {{ element.irenderPoint }}
                            </div>
                            <img class="ml-2" style="opacity: 0.75"
                                src="/static/image/logo-irender-coin.svg" width="12" height="12" />
                        </div>
                        <div title="Bonus point" 
                            class=" d-flex justify-content-end align-items-center flex-row mt-1 " 
                            :style="`${element.bonusPoint === 0 ? 'opacity: 0.25' : '' }`">
                            <div style="color: black">
                                {{ element.bonusPoint }}
                            </div>
                            <i class="el-icon-coin ml-2" style="margin-top: 0.2rem"></i>
                        </div>
                    </div>
                </td>
                <td class="v-center text-nowrap text-right pt-2 pb-2">
                    
                </td>
                <td></td>
            </tr>
        </tbody>
    </table>
</template>
<script>
export default {
    props: {
        listData: {
            type: Array,
            default() {
                return []
            }
        },
        dict: {
            type: Object,
            default() {
                return {}
            }
        },
        actions: {
            type: Object,
            default() {
                return {}
            }
        },
    }
}
</script>